// Build-time env wins. In the browser, use same origin so /api/* hits the ALB (443) and path rules
// route to Django — do not append :8002 (that port is only on the instance, not public).
// Local dev: page is http://localhost:3002 and package.json "proxy" forwards /api to 8002.
function getApiUrl() {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return 'http://127.0.0.1:8002';
}
export const API_URL = getApiUrl();
